import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=5d8d798e&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d8d798e')) {
      api.createRecord('5d8d798e', component.options)
    } else {
      api.reload('5d8d798e', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=5d8d798e&", function () {
      api.rerender('5d8d798e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wCgR3LYWV0Q6/JS/comp/openstreetmap.vue"
export default component.exports